import {Component, EventEmitter, OnInit, Output, Input} from '@angular/core';
import {RequestService} from "../../../../services/api/v1/request.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CustomMessageService, UtilService} from "library";
import {HttpStatusCode} from "@angular/common/http";
import {SalesWorkflowSteps, SalesWorkflow} from "projects/store/src/app/enums";
import {MacroFlowService} from "projects/store/src/app/services/api/v1/macro-flow.service";
import {EMPTY_TOP_UP_LOAN, TopUpLoan} from "projects/store/src/app/interfaces";
import {forkJoin} from "rxjs";

@Component({
  selector: 'app-sales-accept-credit-conditions-top-up-loan',
  templateUrl: './sales-accept-credit-conditions-top-up-loan.component.html',
  styles: [
  ]
})
export class SalesAcceptCreditConditionsTopUpLoanComponent implements OnInit {
  @Input() request: any;
  @Input() showChangeProductButton: boolean = true;
  requestId: string;
  flowCode: string;
  categoryCode: string;
  categoryList: any[] = [];
  topUpLoan: TopUpLoan = { ...EMPTY_TOP_UP_LOAN };
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();


  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private router: Router,
              private utilService: UtilService,
              public macroFlowService: MacroFlowService,
              private customMessageService: CustomMessageService) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.categoryCode = this.route.snapshot.params['category_code'];
    this.request = this.requestService.request;
  }

  ngOnInit() {
    this.load();
   }

  load() {
    this.utilService.enablePageLoading();

    forkJoin({
      categories: this.requestService.getCategoriesList(this.requestId),
      topUpLoan: this.requestService.getTopUpLoan(this.requestId)
    }).subscribe({
      next: ({ categories, topUpLoan }) => {
        if (categories.status === HttpStatusCode.Ok) {
          this.categoryList = categories.body.data.list;
        } else {
          this.customMessageService.responseError();
        }

        if (topUpLoan.status === HttpStatusCode.Ok) {
          this.topUpLoan = topUpLoan.body.data;
        } else {
          this.customMessageService.responseError();
        }
      },
      error: (error) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      },
      complete: () => {
        this.utilService.disablePageLoading();
      }
    });
  }

  extractCategoryIcon(categoryID: string){
    return this.categoryList.find((category) => category.id === categoryID)?.icon_url;
  }

  onNextStep() {
    this.utilService.enablePageLoading();
    this.nextStepEvent.emit();
  }

  onGotoStep(categoryId: string, stepCode: string) {
    this.utilService.enablePageLoading();
    this.gotoStepEvent.emit({ flowCode: this.flowCode, stepCode, categoryId });
  }

  frecuencyText(frecuency: number) {
    return this.utilService.getFrequencyDescription(frecuency);
  }

  frecuencyTextSingular(frecuency: number) {
    return this.utilService.getFrequencyDescription(frecuency, false, true);
  }

  get subtotalToConsolidate(): number {
    return this.topUpLoan.current_loan.balance - this.topUpLoan.consolidation.discount;
  }

  get hasAdvancePayment(): boolean {
    return this.topUpLoan.advance_payment > 0;
  }

  protected readonly SalesWorkflowSteps = SalesWorkflowSteps;
  protected readonly SalesWorkflow = SalesWorkflow;

}
